import { useGetIdentity } from "ra-core";

import { PageHeader } from "@/components/atomic-crm/ui";

// Salutation personnalisée en tête de TodayPage.

const dateFormatter = new Intl.DateTimeFormat("fr-FR", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
});

function formatDateFr(d: Date) {
  const s = dateFormatter.format(d);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const HomeGreet = () => {
  const { identity } = useGetIdentity();
  const firstName = identity?.fullName?.split(" ")[0] ?? "";
  const dateLabel = formatDateFr(new Date());

  return (
    <PageHeader
      title={
        <>
          Bonjour {firstName}{" "}
          <span className="inline-block" style={{ transform: "rotate(8deg)" }}>
            👋
          </span>
        </>
      }
      subtitle={dateLabel}
    />
  );
};
